export default "__VITE_ASSET__BIuHLaxw__"